import styles from './addonitem.module.sass';
import cn from 'classnames';
import { LazyImage } from '../LazyImage';
import { Price } from '../Price';
import { Skeleton } from '../Skeleton';
import { MovieDetails } from '../MovieDetails';
import { LinkProps, LinkWrapper } from '../LinkWrapper';
import { ImageContainer } from '../ImageContainer';
import { FontIcon, FontIconColor, FontIconName } from '../FontIcon';

interface AddonItemProps extends React.HTMLAttributes<HTMLDivElement> {
    picture?: string;
    logo?: 'string' | React.ReactNode;
    cost?: string;
    currency?: string;
    status?: string;
    statusColor?: 'red' | 'green';
    statusIconName?: FontIconName;
    statusIconColor?: FontIconColor;
    info?: (string | string[] | { [key: string]: string[] })[];
    ctaPlay: LinkProps | React.ReactNode;
    ctaDetails: LinkProps | React.ReactNode;
    isLoading?: boolean;
    isStatic?: boolean;
    prefix?: string;
    suffix?: string;
    // showOnUs?: boolean;
    // onUsText?: string;
    flag?: string;
}

export const AddonItem = ({
    picture,
    logo,
    prefix,
    suffix,
    cost,
    currency,
    status,
    statusColor,
    statusIconName,
    statusIconColor,
    isLoading,
    info = [' '],
    ctaPlay,
    ctaDetails,
    isStatic = false,
    // showOnUs = false,
    // onUsText,
    flag,
    ...props
}: AddonItemProps) => {
    function isLinkProps(obj: any): obj is LinkProps {
        return obj && typeof obj === 'object' && 'linkComponent' in obj;
    }

    if (isLoading) {
        return (
            <div className={styles.addon} {...props}>
                <div className={styles.image}>
                    <Skeleton variant="text" height="100%" />
                </div>
                <Skeleton variant="circle" width={72} height={72} alignment="center" />
                <Skeleton variant="text" height="2rem" width="80%" alignment="center" />
            </div>
        );
    }

    return (
        <div
            className={cn(styles.addon, props.className)}
            {...(isStatic && { style: { cursor: 'pointer' } })}
            {...props}
        >
            <div
                className={cn(styles.bg, isStatic && styles.bgStatic)}
                style={{ backgroundImage: `url(${picture})` }}
            ></div>
            {!isStatic && (
                <>
                    {info && <MovieDetails info={info} />}
                    {typeof logo === 'string' ? (
                        <div className={styles.logo}>
                            <div>
                                <ImageContainer src={logo} alt="" ratio={1.9} />
                            </div>
                        </div>
                    ) : (
                        <div className={styles.logo}>{logo}</div>
                    )}
                    {flag && (
                        <span className={styles.flag}>{flag}</span>
                    )}

                    <div className={styles.foot}>
                        {cost && (
                            <div className={styles.flags}>
                                <Price price={cost} {...(currency && { currency: currency, prefix, suffix })} />
                            </div>
                        )}
                        {status && statusColor === undefined && (
                            <div className={styles.flags}>
                                <Price price={status} />
                            </div>
                        )}
                        {status && statusColor && (
                            <span className={cn(styles.status, styles[`${statusColor}`])}>
                                {statusIconName && (
                                    <FontIcon
                                        name={statusIconName}
                                        // .sub puts a green disc behind the glyph, so it stays white.
                                        color={statusColor === 'green' ? '' : statusIconColor}
                                        className={statusColor === 'green' ? styles.sub : undefined}
                                        size="x-small"
                                        md="x-small"
                                    />
                                )}
                                {status}
                            </span>
                        )}
                        {isLinkProps(ctaPlay) ? <LinkWrapper link={ctaPlay} /> : ctaPlay}
                        {isLinkProps(ctaDetails) ? <LinkWrapper link={ctaDetails} /> : ctaDetails}
                    </div>
                </>
            )}
        </div>
    );
};
